'use client';
import { Transition, Typography } from 'components';
import { FALLBACK_GRAVATAR } from 'constants/images';
import { IMPERSONATE_ID_PERSISTED_STATE } from 'constants/persistedStates';
import usePersistentContext from 'hooks/usePersistenceState';
import Image from 'next/image';
import { useCurrentUser } from 'providers/UserProvider/useCurrentUser';
import { FC, useEffect, useMemo } from 'react';
import { cn } from 'utils/cn';
import Arrow from './Arrow';

interface IPerson {
  open?: boolean;
}

const Person: FC<IPerson> = ({ open }) => {
  const { data: currentUser, refetch } = useCurrentUser();
  const [impersonateToken] = usePersistentContext(IMPERSONATE_ID_PERSISTED_STATE);

  const { data } = useCurrentUser();

  const imageUrl = useMemo(
    () => `https://gravatar.com/avatar/${data?.gravatarEmailHash}?d=${FALLBACK_GRAVATAR}&s=${200}`,
    [data?.gravatarEmailHash]
  );

  useEffect(() => {
    if (impersonateToken) refetch();
  }, [impersonateToken, refetch]);

  return (
    <Transition yInitial={0}>
      <div className="m-2 items-center">
        <div className="flex w-full cursor-pointer items-center">
          <Image
            alt="user-img"
            className=" h-8 shrink-0 rounded-full bg-white"
            height={32}
            width={32}
            src={imageUrl}
            priority={false}
          />
          <span className="ml-4 w-full select-none text-lg leading-normal text-white transition duration-500 ease-in-out ">
            <span className={cn('absolute top-0 h-0', !impersonateToken ? 'hidden' : '')}>
              <Typography variant="light5" align="left" className="!leading-[0rem]">
                Impersonating:
              </Typography>
            </span>
            <Typography variant="regular3" align="right" className="text-right">
              {currentUser?.name ? currentUser?.name : ''}
            </Typography>
          </span>
          <Arrow open={open} className="fill-white" classNameParent="my-2 ml-4" />
        </div>
      </div>
    </Transition>
  );
};

export default Person;
